define('enums/outbound/DialingModes',[
   'lib/knockout',
   'lib/lodash4'
], function (
    ko,
    _
) {
    'use strict';

    /*
     * Enums for dialing modes. To add a new enum, just add the id
     * (as defined by the backend) of the new dialing mode to the
     * array of modes.
     *
     * Example enum:
     *
     * POWER: {
     *     id: 'power',
     *     equals: function (dialingMode) {
     *         return ko.toJS(dialingMode).id === 'power';
     *     }
     * }
     */

    var modes = ['agentless', 'power', 'predictive', 'preview', 'progressive'];

    var DIALING_MODES = {};

    _.forEach(modes, function (mode) {
        DIALING_MODES[mode.toUpperCase()] = {
            id: mode,
            equals: function (dialingMode) {
                return ko.toJS(dialingMode).id === mode;
            }
        };
    });

    return DIALING_MODES;
});

